import { StringEnum } from "../../../typescript/StringEnum";

// TODO: Typescript 2.4 enum string types
export const BfxFindDealsFilterFieldName = StringEnum({
  // most of these are on V_ORDER_DATA

  ORDER_ID: "orderRef",
  // Maps to DEAL_ID on V_TRADE_DATA
  TRADE_ID: "dealRef",

  STRATEGY_ID: "strategyRef",

  // Maps to CL_ORD_ID on V_TRADE_DATA
  EXTERNAL_REF: "clOrdId",
  // Booking UTI is a Flexism that maps to BOOKING_IDS on V_TRADE_DATA

  // TYPEO ON Server
  BOOKING_UTI: "bookindIds",

  // MANUAL DEAL REF in spec
  EXTERNAL_DEAL_ID: "externalDealId",

  NETTING_ID: "nettingId",
  FWD_NETTING_ID: "fwdNettingId",

  // Client
  CLIENT_ID: "clientCode",
  CLIENT_NAME: "clientName",
  ACCOUNT_ID: "accountCode",
  ACCOUNT_NAME: "accountName",
  CLIENT_TRADER: "clientTraderName",
  BRANCH: "clientBranchCode",
  SALES_GROUP: "salesGroupId",
  CHANNEL: "channelCd",

  TRADER_GROUP: "traderGroupId",

  CCY: "ccy",
  INSTRUMENT: "instrument",
  //??
  CCY_PAIR_GROUP: "ccyPairGroup",

  TYPE: "requestOrderType",

  ENTRY_DATE: "entryDate",
  ENTRY_USER: "entryUserId",
  FILL_DATE: "fillDate",
  FILL_USER: "fillUserId",
  VALUE_DATE: "valueDate",
  TRADE_DATE: "tradeDate",

  FILL_AMT: "fillAmount",
  FILL_AMT_USD: "usdFillAmount",

  //rate mapping
  MARKET_SPOT: "marketSpot",
  MARKET_ALL_IN: "marketAllIn",
  CLIENT_SPOT: "clientSpot",
  CLIENT_ALL_IN: "clientAllIn",

  // note from spec Should cover all states ungrouped.
  DEAL_STATE: "dealState",

  //product mapping
  PRODUCT: "product",

  //fix code mapping
  FIXCODE: "fixingSourceCd",

  //fixing date
  FIXING_DATE: "fixingDate",

  FIXING_TIME: "fixingTime",

  // Benchmarks
  BM_FIXCODE: "fixingCode",
  SEARCH_IN_TZ: "timezoneCd",

  // OBOs
  OBO_CLIENT: "oboClient",
  OBO_ACCOUNT: "oboAccount",

  LAST_MARKET: "lastMkt",
  TRADE_TYPE: "tradeType",
});
